<template>
    <div class="department-staff-management">
        部门人员管理
    </div>
</template>

<script>
    export default {
        name: "department-staff-management"
    }
</script>

<style scoped>

</style>